import type {
  OptionSetLoadFailure
} from '../utils/optionSetLoad'

interface OptionSetUnavailableProps {
  failure: OptionSetLoadFailure
  onRetry: () => void
  className: string
}

/**
 * What a public options page shows when it has no set to render.
 *
 * "Expired" only for a set the backend says is gone; any other failure keeps
 * the link and offers a retry, since the set is still there (GET-16564).
 */
export function OptionSetUnavailable({
  failure, onRetry, className
}: OptionSetUnavailableProps): JSX.Element {
  if (failure === 'expired') {
    return (
      <div className={className}>
        <h1 className="font-display text-3xl">This link has expired</h1>
        <p className="mt-3 text-gray-600">
          These options aren&apos;t available anymore. Just message your
          assistant and it&apos;ll pull up a fresh set.
        </p>
      </div>
    )
  }
  return (
    <div className={className}>
      <h1 className="font-display text-3xl">These options didn&apos;t load</h1>
      <p className="mt-3 text-gray-600">
        This page couldn&apos;t reach your options just now. Check your
        connection and try again.
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-6 rounded-full bg-catch-red px-5 py-2 text-sm font-medium text-catch-white transition-opacity hover:opacity-90"
      >
        Try again
      </button>
    </div>
  )
}
